import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ImportMappedProjectService } from 'src/app/Services/import-mapped-project.service';
import { ReportDashboardService } from 'src/app/Services/report-dashboard.service';
import {
  ReportDashboardService as ReportService,
  TestSummary,
 
} from 'src/app/Services/report-dashboard.service';
@Component({
  selector: 'ze-reportdashboard',
  templateUrl: './reportdashboard.component.html',
  styleUrls: ['./reportdashboard.component.scss']
})
export class ReportdashboardComponent implements OnInit {

  activeTab: string = 'executive';
  period: string = 'ALL'; // For backward compatibility, keeping this for quality tab
  teamPeriod: string = 'ALL';
  qualityPeriod: string = 'ALL';
  readonly PAGE_SIZE = 10;
  currentDate = new Date();
  defaultAccountId: string = '';
  selectedAccountId: string = '';
  selectedProjectId: string = '';
  adminAccounts: any[] = [];
  accountProjects: any[] = [];
  // Executive Summary Data
  executiveSummary = {
    totalTests: 0,
    passed: 0,
    failed: 0,
    passRate: 0,
    totalExecutions: '0',
    avgTestDuration: '0m 0s',
    reportGenerated: 0,
    automationRate: 0
  };

  executionHoursData = {
    testExecutionHours: '0h 0m',
    overallExecutionHours: '0h 0m'
  };

  criticalIssuesCount: number = 0;

  categoryChartData: any = {
    labels: [],
    datasets: []
  };

  // Calculate dynamic width based on number of categories
  getCategoryChartWidth(): number {
    const numberOfCategories = this.categoryChartData.labels ? this.categoryChartData.labels.length : 0;

    // If few categories, return 100% to fill container
    if (numberOfCategories <= 8) {
      return null; // Let it be responsive and fill container
    }

    // For many categories, calculate width
    const widthPerCategory = 70; // Pixels per category bar
    return numberOfCategories * widthPerCategory;
  }

  categoryChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      left: 10,
      right: 10,
      top: 10,
      bottom: 10
    }
  },
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true,
        max: 100,
        callback: function(value) {
          return value + '%';
        }
      },
      scaleLabel: {
        display: true,
        labelString: 'Pass Rate (%)'
      }
    }],
    xAxes: [{
      scaleLabel: {
        display: true,
        labelString: 'Categories'
      },
      ticks: {
        autoSkip: false,
        maxRotation: 45,
        minRotation: 45
      },
      categoryPercentage: 0.9,
      barPercentage: 0.85
    }]
  },
  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        return 'Pass Rate: ' + tooltipItem.yLabel + '%';
      }
    }
  }
};


  priorityData = [
    { priority: 'Critical', total: 45, passed: 32, failed: 10, blocked: 3 },
    { priority: 'High', total: 82, passed: 68, failed: 11, blocked: 3 },
    { priority: 'Medium', total: 95, passed: 78, failed: 12, blocked: 5 },
    { priority: 'Low', total: 25, passed: 20, failed: 2, blocked: 3 }
  ];

  environmentData = [
    { name: 'Dev', passed: 95, failed: 5 },
    { name: 'QA', passed: 88, failed: 12 },
    { name: 'Staging', passed: 82, failed: 18 },
    { name: 'Production', passed: 92, failed: 8 }
  ];

  topFailingTests = [
    { testCaseId: 'TC_089', testCaseName: 'Payment Gateway Timeout', failureCount: 15, category: 'Payment', lastFailed: '2h ago', reportLink: '#' },
    { testCaseId: 'TC_156', testCaseName: 'Invalid Card Validation', failureCount: 12, category: 'Payment', lastFailed: '4h ago', reportLink: '#' },
    { testCaseId: 'TC_234', testCaseName: 'Session Expiry', failureCount: 9, category: 'Security', lastFailed: '1h ago', reportLink: '#' },
    { testCaseId: 'TC_067', testCaseName: 'API Rate Limiting', failureCount: 8, category: 'API', lastFailed: '3h ago', reportLink: '#' },
    { testCaseId: 'TC_145', testCaseName: 'Database Connection', failureCount: 7, category: 'Infrastructure', lastFailed: '6h ago', reportLink: '#' }
  ];

  automationProgress = [
    { sprint: 'Sprint 1', automated: 45, manual: 55 },
    { sprint: 'Sprint 2', automated: 52, manual: 48 },
    { sprint: 'Sprint 3', automated: 61, manual: 39 },
    { sprint: 'Sprint 4', automated: 73.5, manual: 26.5 }
  ];

  teamPerformance = [];


  // Chart.js Configurations
  trendChartOptions: any;
  trendChartData: any;
  trendData: any[] = [];

  testCoverage: { module: string; coverage: number }[] = [];

  categoryData: any[] = [];

  defectAnalysis: any[] = [];

  defectChartData: any;
  defectChartOptions: any;

  pieChartOptions: any;
  pieChartData: any;

  public adminDetailsReports: any;
  public isDashboardLoading = false;
  public isUserListLoading = false;
  public isProjectListLoading = false;

  //pagination
  projectStartIndex = 0;
  userStartIndex = 0;

  adminProjectDataStore: any[] = [];
  visibleProjectList: any[] = [];
  userHasNext: boolean = false;
  projectHasNext: boolean = false;
  adminUserDataStore: any[] = [];
  visibleUserList: any[] = [];

  public searchUser: string = '';
  isUserSearchActive: boolean = false;
  userSearchErrorMessage: string = '';

  isProjectSearchActive: boolean = false;
  public searchProject: string = '';
  projectSearchErrorMessage: string = '';
  environmentChartOptions: any;
  environmentChartData: any;

  automationChartOptions: any;
  automationChartData: any;

  constructor(private reportService: ReportDashboardService,
    private importMappedProjectService: ImportMappedProjectService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.isDashboardLoading = true;
    this.isUserListLoading = true;
    this.isProjectListLoading = true;
    this.getDefaultAccount();
  }

  getDefaultAccount() {
  this.reportService.getAdminDefaultAccount().subscribe(
    (res: any) => {
      if (res.operationStatus === 'SUCCESS' && res.data) {
        this.defaultAccountId = res.data; // <-- accountId (_id)

        // Fetch admin accounts first, then initialize
        this.getAdminAccounts();
      }
    },
    error => {
      // Still try to fetch admin accounts even if default fails
      this.getAdminAccounts();
    }
  );
}

afterDefaultAccountLoaded() {
  // Only proceed if selectedAccountId is set
  if (!this.selectedAccountId) {
    // Wait a bit for accounts to load and account to be selected
    setTimeout(() => {
      if (this.selectedAccountId) {
        this.loadAllData();
      }
    }, 100);
    return;
  }
  
  this.loadAllData();
}

loadAllData() {
  this.initializeCharts();

  // Load real data from API
  this.loadReportData();
  this.getAdminUserList(0);
  this.loadCategoryPassRate();
  this.loadDefectSeverityData();
  this.getDashboardCards();
    this.getAdminProjectList(0);
    this.loadTrendChart();
    this.getExecutionHours(this.qualityPeriod);
}

onAccountChange() {
  // Ensure selectedAccountId is a string (not an object)
  if (this.selectedAccountId) {
    this.selectedAccountId = String(this.selectedAccountId);
  } else {
    return;
  }
  
  // Save selected account to localStorage
  localStorage.setItem('selectedAccountId', this.selectedAccountId);
  
  // Clear project selection when account changes
  this.selectedProjectId = '';
  this.accountProjects = [];
  
  // Fetch projects for the selected account
  this.getAccountProjects(this.selectedAccountId);
  
  // Reset all data stores
  this.adminProjectDataStore = [];
  this.visibleProjectList = [];
  this.projectStartIndex = 0;
  this.projectHasNext = false;
  
  this.adminUserDataStore = [];
  this.visibleUserList = [];
  this.userStartIndex = 0;
  this.userHasNext = false;
  this.teamPerformance = [];
  
  // Clear search states
  this.searchProject = '';
  this.projectSearchErrorMessage = '';
  this.isProjectSearchActive = false;
  this.searchUser = '';
  this.userSearchErrorMessage = '';
  this.isUserSearchActive = false;
  
  // Reload all data with new account
  this.loadAllData();
}

onProjectChange() {
  // Ensure selectedProjectId is a string
  if (this.selectedProjectId) {
    this.selectedProjectId = String(this.selectedProjectId);
  } else {
    this.selectedProjectId = '';
  }
  
  // Clear cached data stores when project changes
  this.adminProjectDataStore = [];
  this.visibleProjectList = [];
  this.projectStartIndex = 0;
  this.projectHasNext = false;
  
  this.adminUserDataStore = [];
  this.visibleUserList = [];
  this.userStartIndex = 0;
  this.userHasNext = false;
  this.teamPerformance = [];
  
  // Clear search states
  this.searchProject = '';
  this.projectSearchErrorMessage = '';
  this.isProjectSearchActive = false;
  this.searchUser = '';
  this.userSearchErrorMessage = '';
  this.isUserSearchActive = false;
  
  // Reload all data with new project selection
  this.loadAllData();
}

getAdminAccounts(){
  this.importMappedProjectService.getOrgAccNo().subscribe(
    (res: any) => {
      if (res.operationStatus === 'SUCCESS' && res.data) {
        // Extract accountId and accountNo from the response
        // Handle _id structure: it can be { $oid: "..." } or a plain string
        this.adminAccounts = res.data.map((account: any) => {
          let accountId: string;
          
          // Handle MongoDB ObjectId structure
          if (account._id) {
            if (typeof account._id === 'string') {
              accountId = account._id;
            } else if (account._id.$oid) {
              accountId = account._id.$oid;
            } else if (typeof account._id === 'object' && account._id.toString) {
              accountId = account._id.toString();
            } else {
              accountId = account.accountId || '';
            }
          } else {
            accountId = account.accountId || '';
          }
          
          return {
            accountId: accountId,
            accountNo: account.accNo || account.accountNumber || ''
          };
        });
        
        // Initialize selectedAccountId after accounts are loaded
        this.initializeSelectedAccount();
      }
    },
    error => {
      console.error('Failed to fetch admin accounts', error);
    }
  );
}

initializeSelectedAccount() {
  // Check localStorage first for persisted account selection
  const savedAccountId = localStorage.getItem('selectedAccountId');
  
  // Convert all accountIds to strings for comparison
  const accountIds = this.adminAccounts.map(acc => String(acc.accountId));
  
  if (savedAccountId && accountIds.includes(savedAccountId)) {
    // Use saved account if it exists in the list
    this.selectedAccountId = savedAccountId;
  } else if (this.defaultAccountId) {
    // Convert defaultAccountId to string for comparison
    const defaultIdStr = String(this.defaultAccountId);
    
    // Check if default account exists in the list
    if (accountIds.includes(defaultIdStr)) {
      this.selectedAccountId = defaultIdStr;
    } else if (this.adminAccounts.length > 0) {
      // If default account not found, use first account
      this.selectedAccountId = String(this.adminAccounts[0].accountId);
    } else {
      this.selectedAccountId = defaultIdStr;
    }
    
    localStorage.setItem('selectedAccountId', this.selectedAccountId);
  } else if (this.adminAccounts.length > 0) {
    // Use first account as fallback
    this.selectedAccountId = String(this.adminAccounts[0].accountId);
    localStorage.setItem('selectedAccountId', this.selectedAccountId);
  }
  
  // Once account is selected, fetch projects for that account
  if (this.selectedAccountId) {
    // Ensure selectedAccountId is a string
    this.selectedAccountId = String(this.selectedAccountId);
    
    // Fetch projects for the selected account
    this.getAccountProjects(this.selectedAccountId);
    
    // Use setTimeout to ensure Angular has updated the model binding
    setTimeout(() => {
      this.afterDefaultAccountLoaded();
    }, 0);
  }
}

  loadTrendChart() {
    if (!this.selectedAccountId) return;
    
    const accountId = String(this.selectedAccountId);
    const projectId = this.selectedProjectId ? String(this.selectedProjectId) : null;
    this.reportService.getTestExecutionTrend(accountId, projectId).subscribe((response: any[]) => {

      this.trendData = response;

      this.trendChartData = {
        labels: this.trendData.map(d => d.week),
        datasets: [
          {
            label: 'Passed',
            data: this.trendData.map(d => d.passedExecutions),
            backgroundColor: 'rgba(16, 185, 129, 0.5)',
            borderColor: 'rgb(16, 185, 129)',
            borderWidth: 2,
            fill: true
          },
          {
            label: 'Failed',
            data: this.trendData.map(d => d.failedExecutions),
            backgroundColor: 'rgba(239, 68, 68, 0.5)',
            borderColor: 'rgb(239, 68, 68)',
            borderWidth: 2,
            fill: true
          },
          {
            label: 'Aborted',
            data: this.trendData.map(d => d.abortedExecutions),
            backgroundColor: 'rgba(245, 158, 11, 0.5)',
            borderColor: 'rgb(245, 158, 11)',
            borderWidth: 2,
            fill: true
          }
        ]
      };

      let maxValue = 0;

      this.trendData.forEach(d => {
        maxValue = Math.max(
          maxValue,
          d.passedExecutions,
          d.failedExecutions,
          d.abortedExecutions
        );
      });
      this.trendChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: true,
            suggestedMax: maxValue === 0 ? 10 : maxValue + 10,
            ticks: {
              stepSize: maxValue === 0 ? 2 : Math.ceil((maxValue + 10) / 5)   // optional: matches your earlier 20,40,60 scaling
            }
          }
        }
      };
    });
  }

  getDashboardCards() {
    if (!this.selectedAccountId) return;
    
    const accountId = String(this.selectedAccountId);
    const projectId = this.selectedProjectId ? String(this.selectedProjectId) : null;
    this.reportService.getDashboardCards(this.qualityPeriod, accountId, projectId).subscribe({
      next: (res: any) => {
        this.adminDetailsReports = res;
        this.isDashboardLoading = false;
      }, error: () => {
        this.isDashboardLoading = false;
      }
    });
  }

  getAdminProjectList(startIndex: number) {
    this.projectStartIndex = startIndex;

    const start = startIndex;
    const end = startIndex + this.PAGE_SIZE;

    const alreadyFetched = this.adminProjectDataStore.length > end || start < this.adminProjectDataStore.length;

    if (alreadyFetched) {
      // Use cached data
      this.visibleProjectList = this.adminProjectDataStore.slice(start, end);

      // Check if there's more data
      this.projectHasNext = this.adminProjectDataStore.length > end;
    } else {
      this.isProjectListLoading = true;
      const payload: any = {
        timeRange: this.qualityPeriod,
        startRange: this.projectStartIndex,
        search: false,
        searchParameter: "",
        accountId: String(this.selectedAccountId)
      };
      if (this.selectedProjectId) {
        payload.projectId = String(this.selectedProjectId);
      }
      this.reportService.getProjectDetails(payload).subscribe({
        next: (res: any) => {
          const newData = res.data || [];
          this.visibleProjectList = newData;
          this.projectHasNext = res.hasNext;
          this.adminProjectDataStore = this.adminProjectDataStore.concat(newData);
          this.isProjectListLoading = false;
        },
        error: () => {
          this.isProjectListLoading = false;
        }
      });
    }
  }
  // Add User Modal properties
  showAddUserModal: boolean = false;
  addUserForm: FormGroup;
  isCreatingUsers: boolean = false;
  userCreationMessage: string = '';
  userCreationSuccess: boolean = false;


  get userFields(): FormArray {
    return this.addUserForm.get('users') as FormArray;
  }

  addUserField(): void {
    this.userFields.push(this.createUserFormGroup());
  }

  removeUserField(index: number): void {
    if (this.userFields.length > 1) {
      this.userFields.removeAt(index);
    }
  }

  // Add User Modal Methods
  initializeAddUserForm(): void {
    this.addUserForm = this.fb.group({
      users: this.fb.array([
        this.createUserFormGroup()
      ])
    });
  }

  createUserFormGroup(): FormGroup {
    return this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      emailID: ['', [Validators.required, Validators.email]],
      contactNo: ['', [Validators.required]],
      designation: ['', [Validators.required]]
    });
  }

  openAddUserModal(): void {
    this.showAddUserModal = true;
    this.userCreationMessage = '';
    this.userCreationSuccess = false;
    // Reset form to have one user field
    this.userFields.clear();
    this.userFields.push(this.createUserFormGroup());
  }


  closeAddUserModal(): void {
    this.showAddUserModal = false;
    this.userCreationMessage = '';
    this.userCreationSuccess = false;
    this.isCreatingUsers = false;
  }

  loadDefectSeverityData() {
    if (!this.selectedAccountId) return;
    
    const accountId = String(this.selectedAccountId);
    const projectId = this.selectedProjectId ? String(this.selectedProjectId) : null;
    this.reportService.getDefectSeverityReport(accountId, projectId).subscribe(res => {

      // Map API → defectAnalysis
      this.defectAnalysis = res.map((d: any) => ({
        severity: d.name,      // name → severity
        open: d.open,
        inProgress: d.inProgress,
        resolved: d.resolved
      }));

      // ✅ Extract Critical Open Issues
   const critical = res.find((d: any) => d.name && d.name.toLowerCase() === 'critical');
this.criticalIssuesCount = critical ? critical.open : 0;

      // Initialize chart
      this.initializeDefectChart();

       // Build pie chart data
    this.pieChartData = {
      labels: res.map(d => d.name),   // ← label from API
      datasets: [{
        data: res.map(d => d.total),  // ← total from API
        backgroundColor: [
          'rgb(239, 68, 68)',   // critical
          'rgb(251, 146, 60)',  // high
          'rgb(250, 204, 21)',  // medium
          'rgb(156, 163, 175)'  // low
        ]
      }]
    };

    this.pieChartOptions = {
      responsive: true,
      maintainAspectRatio: false
    };
    }
    );
  }

  initializeDefectChart() {
    this.defectChartData = {
      labels: this.defectAnalysis.map(d => d.severity),
      datasets: [
        {
          label: 'Open',
          data: this.defectAnalysis.map(d => d.open),
          backgroundColor: 'rgb(239, 68, 68)'
        },
        {
          label: 'In Progress',
          data: this.defectAnalysis.map(d => d.inProgress),
          backgroundColor: 'rgb(245, 158, 11)'
        },
        {
          label: 'Resolved',
          data: this.defectAnalysis.map(d => d.resolved),
          backgroundColor: 'rgb(16, 185, 129)'
        }
      ]
    };

    this.defectChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          stacked: true
        }],
        yAxes: [{
          stacked: true,
          ticks: { beginAtZero: true }
        }]
      }
    };
  }

  loadCategoryPassRate() {
    if (!this.selectedAccountId) return;
    
    const accountId = String(this.selectedAccountId);
    const projectId = this.selectedProjectId ? String(this.selectedProjectId) : null;
    this.reportService.getPassRateByCategory(accountId, projectId).subscribe({
      next: (data) => {
        const labels = data.map((item: any) => item.name);
        const values = data.map((item: any) => item.count);

        this.categoryChartData = {
          labels: labels,
          datasets: [
            {
              label: 'Pass Rate (%)',
              data: values,
              backgroundColor: '#4CAF50',
              borderWidth: 1
            }
          ]
        };

        // -----------------------
        // FILL TEST COVERAGE CARD
        // -----------------------
        this.testCoverage = data.map((item: any) => ({
          module: item.name,
          coverage: Math.round(item.count * 100) / 100
        }));

        this.categoryData = data.map((item: any) => ({
          category: item.name,
          total: item.total,
          failed: item.open,              // <-- failed = open
          passed: item.count,             // optional
          blocked: 0,                     // optional
          passRate: item.count            // optional, same as before
        }));

      },
      error: (err) => {
        console.error("Error loading category pass rate: ", err);
      }
    });
  }

  initializeCharts() {
    // Trend Chart (Line/Area)
    this.trendChartData = {
      labels: this.trendData.map(d => d.week),
      datasets: [
        {
          label: 'Passed',
          data: this.trendData.map(d => d.passed),
          backgroundColor: 'rgba(16, 185, 129, 0.5)',
          borderColor: 'rgb(16, 185, 129)',
          borderWidth: 2
        },
        {
          label: 'Failed',
          data: this.trendData.map(d => d.failed),
          backgroundColor: 'rgba(239, 68, 68, 0.5)',
          borderColor: 'rgb(239, 68, 68)',
          borderWidth: 2
        },
        {
          label: 'Blocked',
          data: this.trendData.map(d => d.blocked),
          backgroundColor: 'rgba(245, 158, 11, 0.5)',
          borderColor: 'rgb(245, 158, 11)',
          borderWidth: 2
        }
      ]
    };

    this.trendChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: { beginAtZero: true }
        }]
      }
    };

    // Environment Chart
    this.environmentChartData = {
      labels: this.environmentData.map(d => d.name),
      datasets: [
        {
          label: 'Passed',
          data: this.environmentData.map(d => d.passed),
          backgroundColor: 'rgb(16, 185, 129)'
        },
        {
          label: 'Failed',
          data: this.environmentData.map(d => d.failed),
          backgroundColor: 'rgb(239, 68, 68)'
        }
      ]
    };

    this.environmentChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: { beginAtZero: true }
        }]
      }
    };

    // Automation Progress Chart
    this.automationChartData = {
      labels: this.automationProgress.map(d => d.sprint),
      datasets: [
        {
          label: 'Automated %',
          data: this.automationProgress.map(d => d.automated),
          borderColor: 'rgb(16, 185, 129)',
          backgroundColor: 'transparent',
          borderWidth: 3
        }
      ]
    };

    this.automationChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{
          ticks: { beginAtZero: true, max: 100 }
        }]
      }
    };
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  loadReportData() {
    if (!this.selectedAccountId) return;
    
    const accountId = String(this.selectedAccountId);
    const projectId = this.selectedProjectId ? String(this.selectedProjectId) : null;
    
    // Load data from API
    this.reportService.getSummary(accountId, projectId).subscribe(
      (data: TestSummary) => {
        this.executiveSummary = data;
      },
      error => console.error('Error loading summary:', error)
    );

    // Load top failing test cases
    this.reportService.getTopFailingTests(accountId, projectId).subscribe(
      (data: any[]) => {
        this.topFailingTests = data ? data : [];
      },
      error => {
        console.error('Error loading failing tests:', error);
        this.topFailingTests = [];
      }
    );
  }

  onTeamPeriodChange() {
    this.isUserListLoading = true;

    // CRITICAL: Clear cached data and reset pagination for users
    this.adminUserDataStore = [];
    this.visibleUserList = [];
    this.userStartIndex = 0;
    this.userHasNext = false;
    this.teamPerformance = [];

    // Clear search state if active
    if (this.isUserSearchActive) {
      this.searchUser = '';
      this.userSearchErrorMessage = '';
      this.isUserSearchActive = false;
    }
    
    // Reload team data with new period
    this.getAdminUserList(0);
  }

  onQualityPeriodChange() {
    this.isDashboardLoading = true;
    this.isProjectListLoading = true;

    // CRITICAL: Clear cached data and reset pagination for projects
    this.adminProjectDataStore = [];
    this.visibleProjectList = [];
    this.projectStartIndex = 0;
    this.projectHasNext = false;

    // Clear search state if active
    if (this.isProjectSearchActive) {
      this.searchProject = '';
      this.projectSearchErrorMessage = '';
      this.isProjectSearchActive = false;
    }
    
    // Reload quality data with new period
    this.getDashboardCards();
    this.getAdminProjectList(0);
    this.getExecutionHours(this.qualityPeriod);
  }
  
  getSelectedAccountNo(): string {
    const account = this.adminAccounts.find(acc => acc.accountId === this.selectedAccountId);
    return account ? account.accountNo : '';
  }

  getAdminUserList(startIndex: number) {
    this.userStartIndex = startIndex;

    const start = startIndex;
    const end = startIndex + this.PAGE_SIZE;

    const alreadyFetched = this.adminUserDataStore.length > end || start < this.adminUserDataStore.length;

    if (alreadyFetched) {
      // Use cached data
      this.visibleUserList = this.adminUserDataStore.slice(start, end);

      // ✅ CRITICAL: Map the visible list to teamPerformance for display
      this.teamPerformance = this.visibleUserList.map((user: any) => {
        const executed = user.noOfExecutions ? user.noOfExecutions : 0;
        const failed = user.bugSaved ? user.bugSaved : 0;
        const aborted = user.aborted ? user.aborted : 0;
        const passed = executed - (failed + aborted);
        const passedRate = executed > 0 ? (passed / executed) * 100 : 0;

        return {
          tester: user.name ? user.name : user.userName,
          executed: executed,
          failed: failed,
          passed: passed,
          passedRate: Number(passedRate.toFixed(2)),
          efficiency: Number(passedRate.toFixed(2))
        };
      });

      // Check if there's more data
      this.userHasNext = this.adminUserDataStore.length > end;
    } else {
      this.isUserListLoading = true;
      const payload: any = {
        timeRange: this.teamPeriod,
        startRange: this.userStartIndex,
        search: false,
        searchParameter: "",
        accountId: String(this.selectedAccountId)
      };
      
      if (this.selectedProjectId) {
        payload.projectId = String(this.selectedProjectId);
      }

      this.reportService.getUserDetails(payload).subscribe({
        next: (res: any) => {
          const newData = res.data || [];
          
          this.visibleUserList = newData;
          
          // Map for display
          this.teamPerformance = newData.map((user: any) => {
            const executed = user.noOfExecutions ? user.noOfExecutions : 0;
            const failed = user.bugSaved ? user.bugSaved : 0;
            const passed = executed - failed;
            const passedRate = executed > 0 ? (passed / executed) * 100 : 0;

            return {
              tester: user.name ? user.name : user.userName,
              executed: executed,
              failed: failed,
              passed: passed,
              passedRate: Number(passedRate.toFixed(2)),
              efficiency: Number(passedRate.toFixed(2))
            };
          });

          // Respect backend's hasNext
          this.userHasNext = res.hasNext;
          // Add new data to local store
          this.adminUserDataStore = this.adminUserDataStore.concat(newData);
          this.isUserListLoading = false;
        },
        error: () => {
          this.isUserListLoading = false;
        }
      });
    }
  }

// Public method called from template
exportPDF() {
  // this.exportPDFAsync();
}

// async exportPDFAsync() {
//   console.log("Starting PDF export...");
  
//   const pdf = new jsPDF('p', 'mm', 'a4');
//   const pageWidth = 210;
//   const pageHeight = 297;
//   const margin = 10;
  
//   // Store original tab
//   const originalTab = this.activeTab;
  
//   // Define tabs to export
//   const tabs = ['executive', 'analytics', 'team', 'quality'];
//   const tabNames = {
//     'executive': 'Executive Dashboard',
//     'analytics': 'Detailed Analytics',
//     'team': 'Team Performance',
//     'quality': 'Quality Metrics'
//   };
  
//   try {
//     // Show loading indicator (optional)
//     // this.isExporting = true;
    
//     for (let i = 0; i < tabs.length; i++) {
//       const tab = tabs[i];
      
//       // Switch to the tab
//       this.activeTab = tab;
      
//       // Wait for Angular to render the tab
//       await this.delay(2000);
      
//       // Get the tab container
//       const tabContainer = document.querySelector('.container-scroll') as HTMLElement;
      
//       if (!tabContainer) {
//         console.error(`Tab container not found for ${tab}`);
//         continue;
//       }
      
//       // Add page title
//       if (i > 0) {
//         pdf.addPage();
//       }
      
//       pdf.setFontSize(16);
//       pdf.setTextColor(76, 122, 255);
//       pdf.text(tabNames[tab], margin, margin + 5);
      
//       // Capture the tab content
//       const canvas = await html2canvas(tabContainer, {
//         scale: 2,
//         useCORS: true,
//         logging: false,
//         backgroundColor: '#0a0e1a',
//         windowWidth: tabContainer.scrollWidth,
//         windowHeight: tabContainer.scrollHeight,
//         scrollY: -window.scrollY,
//         scrollX: -window.scrollX
//       });
      
//       const imgData = canvas.toDataURL('image/png');
//       const imgWidth = pageWidth - (2 * margin);
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
//       let yPosition = margin + 10; // Start below title
//       let heightLeft = imgHeight;
      
//       // First page section
//       const availableHeight = pageHeight - yPosition - margin;
      
//       if (imgHeight <= availableHeight) {
//         // Image fits on one page
//         pdf.addImage(imgData, 'PNG', margin, yPosition, imgWidth, imgHeight);
//       } else {
//         // Image needs multiple pages
//         let srcY = 0;
//         let isFirstSection = true;
        
//         while (heightLeft > 0) {
//           const sectionHeight = isFirstSection ? availableHeight : pageHeight - (2 * margin);
//           const srcHeight = (sectionHeight * canvas.width) / imgWidth;
          
//           // Create a section of the canvas
//           const sectionCanvas = document.createElement('canvas');
//           sectionCanvas.width = canvas.width;
//           sectionCanvas.height = Math.min(srcHeight, canvas.height - srcY);
          
//           const ctx = sectionCanvas.getContext('2d');
//           if (ctx) {
//             ctx.drawImage(
//               canvas,
//               0, srcY,
//               canvas.width, sectionCanvas.height,
//               0, 0,
//               canvas.width, sectionCanvas.height
//             );
            
//             const sectionImgData = sectionCanvas.toDataURL('image/png');
//             const sectionImgHeight = (sectionCanvas.height * imgWidth) / canvas.width;
            
//             if (!isFirstSection) {
//               pdf.addPage();
//               yPosition = margin;
//             }
            
//             pdf.addImage(sectionImgData, 'PNG', margin, yPosition, imgWidth, sectionImgHeight);
            
//             srcY += srcHeight;
//             heightLeft -= sectionHeight;
//             isFirstSection = false;
//           }
//         }
//       }
      
//       console.log(`Exported ${tabNames[tab]}`);
//     }
    
//     // Add footer with timestamp
//     const timestamp = new Date().toLocaleString();
//     const totalPages = pdf.getNumberOfPages();
    
//     for (let i = 1; i <= totalPages; i++) {
//       pdf.setPage(i);
//       pdf.setFontSize(8);
//       pdf.setTextColor(150, 150, 150);
//       pdf.text(
//         `Generated: ${timestamp} | Page ${i} of ${totalPages}`,
//         pageWidth / 2,
//         pageHeight - 5,
//         { align: 'center' }
//       );
//     }
    
//     // Save the PDF
//     const filename = `Test_Report_${new Date().toISOString().split('T')[0]}.pdf`;
//     pdf.save(filename);
    
//     console.log("PDF exported successfully!");
    
//   } catch (error) {
//     console.error("Error exporting PDF:", error);
//     alert("Failed to export PDF. Please try again.");
//   } finally {
//     // Restore original tab
//     this.activeTab = originalTab;
//     // this.isExporting = false;
//   }
// }

// Helper method for delays

private delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

exportExcel() {
    console.log('Exporting Excel...');
    // Implement Excel export logic
  }

 calculatePassRate(passed: number, total: number): number {
  if (!total || total === 0) return 0;
  return parseFloat(((passed / total) * 100).toFixed(1));
}

  getDefectDensity(failed: number, total: number): number {
    if (!total || total === 0) return 0;
    return parseFloat(((failed / total) * 100).toFixed(1));
  }

  getDefectClass(density: number): string {
    if (density === 0) return 'bg-info';
    if (density > 15) return 'bg-danger';
    if (density > 10) return 'bg-warning';
    return 'bg-success';
  }

  getExecutionHours(timeRange: string) {
    if (!this.selectedAccountId) return;
    
    const accountId = String(this.selectedAccountId);
    const projectId = this.selectedProjectId ? String(this.selectedProjectId) : null;
    this.reportService.getExecutionHours(timeRange, accountId, projectId).subscribe({
      next: (res: any) => {
       // Format the hours into readable format
      this.executionHoursData.testExecutionHours = this.formatHours(res.avgTestCaseExecutionHours);
      this.executionHoursData.overallExecutionHours = this.formatHours(res.totalExecutionHours);
      },
      error: (err) => {
        console.error("Error fetching execution hours: ", err);
        this.executionHoursData.testExecutionHours = '0h 0m';
        this.executionHoursData.overallExecutionHours = '0h 0m';
      }
    });
  }

  formatHours(hours: number): string {
    if (!hours || hours === 0) return '0h 0m';

    // Convert hours to total minutes
    const totalMinutes = Math.round(hours * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;

    // If hours is 0, just show minutes
    if (h === 0) {
      return `${m}m`;
    }

    // If minutes is 0, just show hours
    if (m === 0) {
      return `${h}h`;
    }

    return `${h}h ${m}m`;
  }
  get hasPassedTests(): boolean {
  return this.executiveSummary && this.executiveSummary.passed > 0;
}

getAccountProjects(accountId: string): void {
  if (!accountId) return;
  
  this.reportService.getAccountProjects(accountId).subscribe(
    (res: any) => {
      if (res.operationStatus === 'SUCCESS' && res.data) {
        // Map projects to ensure consistent ID structure
        this.accountProjects = res.data.map((project: any) => {
          
          let projectId: string;
          // Handle MongoDB ObjectId structure
          if (project._id) {
            if (typeof project._id === 'string') {
              projectId = project._id;
            } else if (project._id.$oid) {
              projectId = project._id.$oid;
            }
          }
          
          return {
            ...project,
            projectId: projectId,
            displayName: project.projectName || project.name || 'Unnamed Project'
          };
        });
      } else {
        // Handle null or empty data
        this.accountProjects = [];
      }
    },
    error => {
      console.error('Failed to fetch projects for account', error);
      this.accountProjects = [];
    }
  );
}
}
